
import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!, $externalMaps: [DeleteExternalMapsInput]!) {
    deleteBudgetLine (input: { id: $id }, externalMaps: $externalMaps) {
        __typename
        ${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BudgetLines/DeleteMutation.js